import PropTypes from 'prop-types';
import { CatTableBody } from '@blocks-react/components/TableBody';
import { CatTableRow } from '@blocks-react/components/TableRow';
import ShareListNameCell from '../ShareListNameCell';
import ShareListRemoveCell from '../ShareListRemoveCell';

const ShareListTableBody = ({ selectedList, removeItemfromSelectedList }) => {
  return (
    <CatTableBody>
      {selectedList.map(
        ({
          customerOrganizationBusinessName,
          customerOrganizationIdentifier
        }) => (
          <CatTableRow key={customerOrganizationIdentifier}>
            <ShareListNameCell
              customerOrganizationBusinessName={
                customerOrganizationBusinessName
              }
              customerOrganizationIdentifier={customerOrganizationIdentifier}
            />
            <ShareListRemoveCell
              removeItemfromSelectedList={removeItemfromSelectedList}
              customerOrganizationIdentifier={customerOrganizationIdentifier}
            />
          </CatTableRow>
        )
      )}
    </CatTableBody>
  );
};
ShareListTableBody.propTypes = {
  selectedList: PropTypes.arrayOf(
    PropTypes.shape({
      customerOrganizationBusinessName: PropTypes.string,
      customerOrganizationIdentifier: PropTypes.string
    })
  ),
  removeItemfromSelectedList: PropTypes.func
};
export default ShareListTableBody;
